module.exports = __webpack_public_path__ + "media/home2-left.e5f7c04c.mp4";